import { render, staticRenderFns } from "./list-group.vue?vue&type=template&id=4ea8af2a&scoped=true&"
import script from "./list-group.vue?vue&type=script&lang=js&"
export * from "./list-group.vue?vue&type=script&lang=js&"
import style0 from "./list-group.vue?vue&type=style&index=0&id=4ea8af2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea8af2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ea8af2a')) {
      api.createRecord('4ea8af2a', component.options)
    } else {
      api.reload('4ea8af2a', component.options)
    }
    module.hot.accept("./list-group.vue?vue&type=template&id=4ea8af2a&scoped=true&", function () {
      api.rerender('4ea8af2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/load-types/list-group.vue"
export default component.exports